
<template>


    <span class="FieldWrapper" @mousedown="OnMouseDown" @blur="OnBlur"      
              :nullable="Nullable"
               :disabled="Enabled == false"
               :MinValue="MinValue"
               :MaxValue="MaxValue"
              :value="m_Value"
          >

         

        <span class="Field" style="min-height:40px;display:inline-block;text-align:left" 
              v-if="State=='Ready'"
              :Name="Name"
               :DataType="DataType"
               :nullable="Nullable"
               :disabled="Enabled == false"
               :MaxLength="MaxLength"
               :MinValue="MinValue"
               :MaxValue="MaxValue"
              :value="m_Value"
     >{{FormattedNumber}}</span>


        <input v-else
               type="number"
                             :Name="Name"

               v-model="m_Value"
               v-on:input="OnValueInput"
               v-on:change="OnValueChange"
               v-on:click="OnClick"
               v-on:blur="OnBlur"
               :class="CssClass"
               :readonly="ReadOnly"
               :DataType="DataType"
               :nullable="Nullable"
               :disabled="Enabled == false"
               :MaxLength="MaxLength"
               :MinValue="MinValue"
               :MaxValue="MaxValue"
               v-show="Visible"
               class="Field"
               ref="Element" />


    </span>

</template>

<script>
    import Utility from '@/Common/Utility'
    import TControlBase from '@/Common/TControlBase';

    export default {
        data() {
            return {
                State: "Ready",

                m_Value: "",

                m_Type: "",

                m_Attribute: {
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    MaxLength: null,
                    DataType:"Number",
                    AutoTrim: false
                }
            };
        }
        ,
        props: ["value", "nullable" , "enabled" , "AutoTrim", "Attribute", "MinValue", "MaxValue", "Keep","KeyName","Name"],


        computed: {

            FormattedNumber: {
                get() {
                    let formattedNumber = "";

                    var formatter = new Intl.NumberFormat();

                    if (this.m_Value == null || this.m_Value == "") {

                        formattedNumber = "";
                    }
                    else {
                        formattedNumber = formatter.format(this.m_Value + "");
                    }

                    if (formattedNumber == "NaN") {
                        debugger;
                    }

                    return formattedNumber;
                }
            },

            InputType: {
                get: function () {
                    let inputType = "text";


                    if (this.DataType == "int") {
                        inputType = "Number";
                    }

                    return inputType;
                }
            },

            CssClass: {

                get: function () {
                    let result = "";


                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                }
            }
            ,
            Nullable: function () {
                if (this.m_Attribute.Nullable == null) {
                    this.m_Attribute.Nullable = false;
                }

                return this.m_Attribute.Nullable + "";
            }
            ,

            ReadOnly: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute != null && this.m_Attribute.ReadOnly != null) {
                        result = this.m_Attribute.ReadOnly;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Enabled: {

                get: function () {
                    let result = true;

                    if (this.m_Attribute != null && this.m_Attribute.Enabled != null) {
                        result = this.m_Attribute.Enabled;
                    }

                    return result;
                }
            }
            ,
            Disabled: {

                get: function () {
                    let result = false;


                    if (this.m_Attribute.Enabled != null) {
                        result = !this.m_Attribute.Enabled;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Visible: {

                get: function () {
                    let result = true;

                    if (this.m_Attribute.Visible != null) {
                        result = this.m_Attribute.Visible;
                    }
                    return result;
                }
            },

            DataType: {

                get: function () {
                    let result = "text";

                    if (this.m_Attribute != null && this.m_Attribute.DataType != null) {
                        result = this.m_Attribute.DataType;
                    }

                    return result;
                }
            },

            MaxLength: {

                get: function () {
                    let result = "128";

                    if (this.m_Attribute != null && this.m_Attribute.MaxLength != null) {
                        result = this.m_Attribute.MaxLength;
                    }

                    return result;
                }
            }

        }
        ,

        methods: {

            OnClick(e) {
                this.$emit("click", e);
            },

            GetValue() {
                return this.m_Value;
            },

            SetValue(value) {
                this.m_Value = value;

                this.$emit("input", value);
            },

            OnMouseDown(e) {
                this.State = "Editting";
            },

            OnBlur(e) {
                let trimValue = "";


                if (this.AutoTrim == "true") {

                    trimValue = e.target.value.trim();
                    e.target.value = trimValue;
                    this.$emit("input", trimValue);

                }

                if (this.KeyName != null && this.KeyName != "") {
                    this.StoreValue();
                }

                this.$emit("blur");

                this.State = "Ready";
            },


            OnValueInput(e) {
                if (this.$refs.Element.nextSibling != null) {
                    if (this.$refs.Element.nextSibling.nodeType == 1) {
                        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                            this.$refs.Element.nextSibling.innerHTML = "";
                        }
                    }
                }

                this.$emit("input", e.target.value);
            },

            OnValueChange(e) {
                if (this.$refs.Element.nextSibling != null) {
                    if (this.$refs.Element.nextSibling.nodeType == 1) {
                        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                            this.$refs.Element.nextSibling.innerHTML = "";
                        }
                    }
                }
                 
                this.$emit("change", e.target.value);
            },

            UpdateElementByAttribute() {

            },

            OnButtonClick() {
                alert("Enabled = " + this.m_Attribute.Enabled);
            }

        },


        created() {

            TControlBase.call(this);


            if (this.enabled != null) {
                if (this.enabled == "true" || this.enabled == "True" || this.enabled == true) {
                    this.m_Attribute.Enabled = true;
                }
                else {
                    this.m_Attribute.Enabled = false;
                }
            }

            if (this.nullable == "false" || this.nullable == false) {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }
             

            if (this.value == null) {
                debugger;

                this.m_Value = "";
            }
            else {
                this.m_Value = this.value;
            }

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            }

            if (this.Keep == true || this.Keep == "true") {
                this.LoadValue();
            }
        },

        watch: {
            Attribute: function (newVal, oldVal) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            },

            nullable: function (newVal, oldVal) {
                this.m_Attribute.Nullable = newVal;
            },

            enabled: function (newVal) {
                if (newVal != null) {
                    if (newVal == "true" || newVal == "True" || newVal == true) {
                        this.m_Attribute.Enabled = true;
                    }
                    else {
                        this.m_Attribute.Enabled = false;
                    }
                }
            } ,

            value: function (newVal, oldVal) {

                if (newVal == null) {
                    debugger;
                    this.m_Value = "";
                }
                else {
                    this.m_Value = newVal;
                }


                if (this.Keep == true || this.Keep == "true") {
                    this.StoreValue();
                }
                this.ClearError();
            }
        }


    }
</script>

<style scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
